import { Injectable } from "@angular/core";
import cssVars from "css-vars-ponyfill";
import { HttpClient } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { SpinnerService } from "../services/spinner.service";
import { appConfig, clientConfig } from "../constant/app.constant";
import { Theme, light, dark, defaultTheme, ikea, sony, schneider, kuehnenagel, Logo, Banner, muji } from "./theme.model";
import { ThemeMapper } from "./theme-mapper";
import { BehaviorSubject } from "rxjs";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private active: Theme = light;
  private availableThemes: Theme[] = [defaultTheme, light, dark, ikea, sony, schneider, kuehnenagel, muji];
  private logoSubject: BehaviorSubject<Logo> = new BehaviorSubject<Logo>({name:'', data: '' as SafeResourceUrl});
  private bannerSubject: BehaviorSubject<Banner> = new BehaviorSubject<Banner>({name:'', data: '' as SafeResourceUrl});

  logo$ = this.logoSubject.asObservable();
  banner$ = this.bannerSubject.asObservable();

  private _url = `${appConfig.BASE_URL}ReturnPortalFacade`;

  constructor(private httpClient: HttpClient, private spinnerService: SpinnerService,private sanitizer: DomSanitizer) {}

  getAvailableThemes(): Theme[] {
    return this.availableThemes;
  }

  getActiveTheme(): Theme {
    return this.active;
  }

  async setActiveThemeByName(themeName: string) {
    let theme: Theme;
    if (clientConfig.MERCHANTCONFIG_IN_DB && clientConfig.MERCHANTCONFIG_IN_DB.toLowerCase().trim() === "true") {
      var response: any;

      try {
        response = await this.fetchThemesFromDB(themeName).toPromise();
      } catch (error) {
        theme = this.availableThemes.find((t) => t.name === 'light');
        console.log(error);
        this.spinnerService.hide();
      }

      if (response && response.success === true && response.theme) {
        theme=ThemeMapper.mapThemeResponse(response);
      }
      else {
        theme = this.availableThemes.find((t) => t.name === 'light');
      }
    }
    else {
      theme = this.availableThemes.find((t) => t.name === themeName);
    }

    if (theme) 
    {
      this.setActiveTheme(theme);
      if(clientConfig.MERCHANTCONFIG_IN_DB && clientConfig.MERCHANTCONFIG_IN_DB.toLowerCase().trim() === "true")
        this.setLogoAndBanner(theme);
    }
    this.spinnerService.hide();
  }
  setActiveTheme(theme: Theme): void {
    this.active = theme;

    Object.keys(this.active.properties).forEach((property) => {
      document.documentElement.style.setProperty(property, this.active.properties[property]);
    });
    this.setThemeForIE(this.active.properties);
  }

  setThemeForIE(ActiveProperties) {
    cssVars({
      onlyLegacy: true,
      watch: true,
      variables: ActiveProperties,
      onComplete(cssText, styleNode, cssVariables) {
        console.log("styleNode", cssText, styleNode, cssVariables);
      },
    });
  }


  fetchThemesFromDB(themeName:string) {

    const result = this.httpClient.get(`${this._url}/Theme/${themeName}`).pipe(
      tap(
        (error: any) => this.spinnerService.hide()
      )
    );
    return result;
  }

  
  setLogoAndBanner(theme: Theme) {
    const logo: Logo = { name: theme.logo.name, data: '' as SafeResourceUrl };
    const banner: Banner = { name: theme.banner.name, data: '' as SafeResourceUrl };
  
    if (this.checkImage(theme.logo.data)) {
      let logoDataUrl = 'data:' + theme.logo.format + ';base64,' + theme.logo.data;
      logo.data = this.sanitizer.bypassSecurityTrustResourceUrl(logoDataUrl);
    }
  
    if (this.checkImage(theme.banner.data)) {
      let bannerDataUrl = 'data:' + theme.banner.format + ';base64,' + theme.banner.data;
      banner.data = this.sanitizer.bypassSecurityTrustResourceUrl(bannerDataUrl);
    }
  
    this.logoSubject.next(logo);
    this.bannerSubject.next(banner);
  }


  checkImage(imageSrc: string):boolean {
    try {
      // Check if there are any non-base64 characters
      if (!imageSrc.match(/^[a-zA-Z0-9+/]*={0,2}$/)) {
        return false;
      }

      // Attempt to decode
      atob(imageSrc);

      return true;
    } catch (err) {
      return false;
    }
  }

  
}
